import Lottie from 'lottie-react';

import anxious from '../data/animations/anxious.json';
import bored from '../data/animations/bored.json';
import energised from '../data/animations/energised.json';
import happy from '../data/animations/happy.json';
import sad from '../data/animations/sad.json';
import grateful from '../data/animations/grateful.json';

const animations = {
  anxious,
  bored,
  energised,
  happy,
  sad,
  grateful
};

export const Emoticon = ({ emotion }) => {
  return (
    <Lottie animationData={animations[emotion.toLowerCase()]} />
  );
};